import { Box, Grid2 as Grid, TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useGetPartnerDropdownsQuery } from "src/shared/api/dropdowns/partner";
import { AutocompleteField } from "src/shared/components";
import { ECountries } from "src/shared/types/common.types";
import { messages } from "src/shared/utils/hookFormRules/messages";
import { postcodeRule } from "src/shared/utils/hookFormRules/rules";

interface IAddressBlockItemProps {
  names: {
    country?: string;
    area?: string;
    region?: string;
    address?: string;
    postcode?: string;
    city?: string;
  };
}

export const AddressBlockItem: FC<IAddressBlockItemProps> = ({ names }) => {
  const { data: dropdowns } = useGetPartnerDropdownsQuery();
  const { country: countriesOptions } = dropdowns || {};
  const { address, country, area, postcode, region, city } = names;
  const { control } = useFormContext();
  const registration_country_id = useWatch({
    control,
    name: "partner.registration_country_id",
  });

  const isRoOrByRegCountry =
    registration_country_id === ECountries.RU ||
    registration_country_id === ECountries.BY;

  return (
    <Box>
      <Grid container spacing={4}>
        {country && (
          <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
            <Controller
              control={control}
              name={country}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <AutocompleteField<number | "", false>
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Страна"
                  error={!!error}
                  helperText={error?.message}
                  options={countriesOptions || []}
                />
              )}
              rules={{
                required: isRoOrByRegCountry ? messages.required : undefined,
              }}
            />
          </Grid>
        )}
        {region && (
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <Controller
              control={control}
              name={region}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Область"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        )}
        {area && (
          <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
            <Controller
              control={control}
              name={area}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Район"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        )}
        {city && (
          <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
            <Controller
              control={control}
              name={city}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Город"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        )}
        {address && (
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <Controller
              control={control}
              name={address}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Адрес"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
              rules={{
                required: isRoOrByRegCountry ? messages.required : undefined,
              }}
            />
          </Grid>
        )}
        {postcode && (
          <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
            <Controller
              control={control}
              name={postcode}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  inputRef={ref}
                  fullWidth
                  {...field}
                  label="Индекс"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
              rules={postcodeRule}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
